import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon DealerRequestsIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const DealerRequestsIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M4.5 22V20.1286C4.5 18.9238 4.95046 17.7683 5.75228 16.9164C6.1016 16.5452 6.99976 16.0001 7.94311 16.0242"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99949 22C9.99949 19.1639 13.9995 18.3941 13.9995 16.07C13.9995 15.422 13.5 15.5 12.4995 15.5001C11.2988 15.5001 10.4995 15.5373 10.4995 16.07C10.4994 18.2024 15.0068 19.5 14.9995 22"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M20 22V20.1286C20 18.9238 19.5495 17.7683 18.7477 16.9164C18.3984 16.5452 17.5002 16.0001 16.5569 16.0242"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4 6.7619C15.8 6.09356 14.36 4.85713 13.4 5.25814C12.44 5.65914 11 5.42522 10.4 5.25814L8.00001 6.7619M16.4 6.7619C16.4 4.77783 15.8 3.50377 17 2C14.6 2.53724 15.2295 2 11.5999 2C7.97032 2 8.00001 3.63258 8.00001 6.7619M16.4 6.7619C16.4 8.80406 16.2474 10.8763 14 12C13.4001 12.2999 11.7325 12.5602 10.5 12C8.79562 11.2253 8.00001 9.53027 8.00001 6.7619"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
export default DealerRequestsIcon
